import { Helmet } from 'react-helmet';
import {
    Box, Button, Card, CardHeader, CardActions, CardContent, Chip,
    Container, Divider, Link,
    Grid, Typography,
    usePagination,
    MenuItem,
    Select,
    TextField,
    InputAdornment,
    Tabs,
    Tab,
    Collapse,
    Paper,
    FormControl,
    FormHelperText,
} from '@mui/material';
import * as Yup from 'yup';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useMemo } from "react";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import { Formik } from "formik";
import imgFaq from "../../../../assets/images/faq/img_faq.svg";
import background from "../../../../assets/images/faq/img_bg_faq.svg";
import cssVariables from "../../../../theme/cssVariables";
import Search from "@mui/icons-material/Search";
import { ReactComponent as Add } from "../../../../assets/images/faq/icon-add.svg";
import { ReactComponent as Readmore } from "../../../../assets/images/faq/icon-readmore.svg";
import { ReactComponent as Arrow } from "../../../../assets/images/faq/icon_arrow.svg";
import { ReactComponent as SendSucess } from "../../../../assets/images/faq/img_sendSucess.svg";
import { LowPriority } from '@mui/icons-material';
import { height, maxWidth, style } from '@mui/system';
import faqsService from "../../../../services/faqs.service";
import * as Util from "../../../../services/global.service";


const styles = {
    path: {
        color: "#68717A",
    },
    paPlanning: {
        marginTop: "-12px",
        marginLeft: "19px",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    lastToolBar: {
        marginTop: "0px",
    },
    blueBadge: {
        background: "rgba(93, 161, 150, 0.15)",
        padding: "5px 12px",
        color: "#5DA196",
        border: "1px solid #5DA196",
        borderRadius: "4px"
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    colorText: {
        color: "#404349",
        fontWeight: "400",
        paddingLeft: "10px"
    },
    box: {
        width: "calc(50% - 30px)",
        "flex-direction": "row",
        margin: "15px 15px",
    },
    content: {
        background: "#FFFFFF",
        "box-shadow": "0px 0px 5px rgba(0, 0, 0, 0.1)",
        "border-radius": "10px",
        padding: "17px 22px",
        height: "100%",
    },


    paperContainer: {
        backgroundImage: `url(${background})`,
        width: "100%",
        backgroundSize: "cover",
        maxHeight: "100%",
        height: "590px",
        backgroundRepeat: "no-repeat",
        position: "relative",
    },

    arrow: {
        width: '15px',
        height: '12px',
        marginLeft: '18px',
    },

    container: {
        padding: "22px 25px 145px 24px",
    },

    title: {
        paddingBottom: "21px",
        borderBottom: "1px solid #E7E8E7",
        fontWeight: "500"
    },

    subTitle: {
        whiteSpace: "nowrap",
        paddingTop: "8px",
        marginRight: "44px"
    },

    textError: {
        marginTop: "6px",
        marginBottom: '30px'
    },

    textField: {
        border: "none !important"
    }
};





const useStyles = makeStyles({
    swiperStyles: {
        paddingTop: "10px !important"

    },
    iconContainer: {
        '& svg': {
            width: "45px",
            height: "45px"
        }
    },
    statusBadge: {
        maxWidth: "150px",
        borderRadius: "5px",
        padding: "5px 12px",
        margin: "0",
    },
    processBgGoals: {
        background: "#4085C9 !important",
        "&:hover": {
            backgroundColor: "#4085C9 !important",
        },
    },

    processBgCompetency: {
        background: "#958CCB !important",
    },

    TextField: {

        '& div > input': {
            padding: "8.5px 10px 8.5px 15px !important",
            fontSize: "18px",
            fontWeight: "300",
            font: "unset",
            "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                "-webkit-appearance": "none",
                display: "none"
            }

        },

        "& > p.Mui-error": {
            position: "absolute",
            bottom: "-22px",
            whiteSpace: "nowrap"

        }

    },
})

const Question = () => {

    const { t } = useTranslation()
    const [mainData, setMainData] = React.useState(
        {
            books_type: [
                {
                    type: "rubric"
                },
                {
                    type: "kpi"
                },
                {
                    type: "common"
                }
            ],


            emp:
            {
                email: "cc.nnyng@gmail.com"
            },

        }

    );

    const [currentPage, setCurrentPage] = React.useState(1);
    const [totalPage, setTotalPage] = React.useState(1);
    const [dataHandBooks, setDataList] = React.useState({});
    const [search, setSearchValue] = React.useState("");
    const [valueTab, setValueTab] = React.useState("rubric");
    const [isCollapse, setCollapse] = React.useState(false);
    const [isCollapseManage, setCollapseManage] = React.useState(false);
    const [valueSerial, setValueSerial] = React.useState('');
    const [selectType, setType] = React.useState("");
    const [selectTypeValue, setTypeValue] = React.useState("");
    const [submit, setSubmit] = React.useState(false);
    const dataProfiles = JSON.parse(localStorage.getItem("user"));
    const [textDescription, setText] = React.useState("");
    const [email, setEmail] = React.useState(dataProfiles !== undefined && dataProfiles !== "undefined" && dataProfiles !== null ? dataProfiles?.profile?.email : "");
    const displayFullName = () => {
        if (dataProfiles !== undefined && dataProfiles !== "undefined" && dataProfiles !== null) {
            setEmail(dataProfiles?.profile?.email)

        }
    }


    const [sendMail, setSendMail] = React.useState(false);

    const handleCollapse = () => {
        setCollapse(!isCollapse)
    }

    const onClickSendMail = () => {
        setSendMail(true)
    }

    const handleChangeWorkloadType = (_, val) => {
        setCurrentPage(1);
        setValueTab(val);
    };

    const handleCollapseManage = (data) => {
        if (data !== valueSerial) {

            setValueSerial(data)

        } else {

            setValueSerial("")

        }

    }



    const getSupportType = () => {
        faqsService.supporttype().then(
            (response) => {
                if (response.data !== undefined && response.data !== null && response.data !== "null") {

                    setType(response.data.support_type);
                }


            },
        );
    }


    const postFaq = () => {
        faqsService.insertfaq(selectTypeValue, textDescription, email).then(
            (response) => {

            },
        );
    }

    const formatData = (data, defaults) => {
        if (data !== null && data !== undefined && data !== "") {
            return data;
        }
        return defaults;
    }



    // handle search

    const handleSearch = (event) => {
        setSearchValue(event.target.value);
    };

    const handleSubmit = () => {
        setSubmit(true);
        postFaq();
    };
    const handleClose = () => {
        setSubmit(false);
        navigate('/kpi/faq/listfaq', { replace: false });
    };


    useEffect(() => {
        // getFaqType();
        // displayFullName();
        getSupportType();

    }, []);


    useEffect(() => {


    }, []);

    const handleGoToDetail = (e) => {
        navigate(`/kpi/manual/contentbooks/${e}`, { replace: false });
    }

    const classes = useStyles();
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }

    const handleChange = (event) => {
        setTypeValue(event.target.value);
    };


    const handleChangeMail = (event) => {
        setEmail(event.target.value);
    };

    const handleSetDescription = (event) => {
        setText(event.target.value);
    };



    return (
        <>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    width: '100%'
                }}
            >

                <Box style={styles.paperContainer}>
                    <Grid container pt={2} pb={2} sx={{ paddingLeft: '20px', paddingTop: '20px' }}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}>{t("faq.label.homePage")}</span> / <span style={styles.end} >{t("faq.label.faqPage")}</span></Typography>
                    </Grid>

                    <Grid sx={{ display: 'flex', alignItems: "flex-end", height: '100%' }}>
                        <Grid lg md xs={12} item m="30px" mt="0px" sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-end' }}>
                            <Grid lg md xs={4} sx={{ maxWidth: "max-content !important" }} >
                                <img src={imgFaq} style={{ maxWidth: '470px', maxHeight: '470px' }}>

                                </img>
                            </Grid>
                            <Grid lg md xs={8} display='flex' justifyContent='center' flexDirection='column' pb="80px" >
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography fontSize={48} lineHeight="52px" fontWeight={600} color="#404349"  >
                                        {t("faq.label.faq")}
                                    </Typography>


                                </Box>

                            </Grid>
                        </Grid>
                    </Grid>

                </Box>

                <Grid container sx={{ borderBottom: "1px solid #e4e4e4" }} mt={4}>

                    <Typography fontSize={48} lineHeight="52px" fontWeight={600} color="rgba(93, 161, 150, 1)" sx={{ paddingLeft: "40px", paddingRight: "40px", paddingTop: "30px", width: "100%", 'text-align': 'center' }}>
                        {t("faq.label.sendRequest")}
                    </Typography>


                    <Grid item lg={12} md={12} p="30px 60px" sx={{ display: 'grid', background: "#FFFFFF", border: '1px solid #E4E4E4', 'border-radius': '10px', margin: '50px' }}>

                        {submit === false ?

                            <Formik
                                // initialValues={{
                                //     username: 'chorchujai.san@nida.ac.th',
                                //     password: 'Chorchujai00'
                                // }}

                                initialValues={{
                                    QuestionType: '',
                                    emailAddress: email,
                                    types: selectTypeValue,
                                }}
                                validationSchema={Yup.object().shape(
                                    {
                                        QuestionType: Yup.string()
                                            .required(t('faq.msg.questionType')),
                                        emailAddress: Yup.string()
                                            .required(t('faq.msg.emailAddress'))
                                            .email(t('login.msg.wrongusername')),
                                        types: Yup.string()
                                            .required(t('faq.msg.selectType'))
                                    }


                                )}
                                onSubmit={(values, { setSubmitting, setErrors, setStatus, resetForm }) => {
                                    setSubmit(true);
                                    faqsService.insertfaq(values.types,values.QuestionType, values.emailAddress).then(
                                        (response) => {
                            
                                        },
                                    );
                                }}
                            >
                                {({
                                    errors,
                                    handleBlur,
                                    handleChange,
                                    handleSubmit,
                                    isSubmitting,
                                    touched,
                                    values
                                }) => (
                                    <form onSubmit={handleSubmit} sx={{
                                        '& .MuiTextField-root': { m: 1, width: '25ch' },
                                    }}>
                                        {selectType.length > 0 ?

                                            <Box>
                                                <Box>
                                                    <Typography fontSize={20} lineHeight="22px" fontWeight={400} color="background: rgba(64, 67, 73, 1)" sx={{ 'padding-bottom': '20px', paddingLeft: "5px" }}>
                                                        {t("faq.label.type")}
                                                    </Typography>
                                                </Box>

                                                <Select

                                                    id="type-select"
                                                    variant="outlined"
                                                    defaultValue=""
                                                    displayEmpty
                                                    size="small"
                                                    name="types"
                                                    fullWidth
                                                    className="white-bg"
                                                    value={values.types}
                                                    onChange={handleChange}
                                                    error={Boolean(touched.types && errors.types)}
                                                    helperText={touched.types && errors.types}

                                                >
                                                    <MenuItem disabled value="">
                                                        <Typography variant="sub_label" style={{ fontWeight: "300" }}> {t("faq.label.selectType")}  </Typography>
                                                    </MenuItem>
                                                    {
                                                        selectType !== undefined && selectType !== null && selectType.length > 0 ? selectType.map((loRow, index) => {

                                                            return (
                                                                <MenuItem value={loRow?.serial} key={loRow?.serial}>
                                                                    {loRow?.name}
                                                                </MenuItem>

                                                            )

                                                        })

                                                            : <MenuItem value="">
                                                                ไม่พบข้อมูล
                                                            </MenuItem>

                                                    }

                                                </Select>
                                                {Boolean(touched.types && errors.types) ? (<FormHelperText error sx={{ marginTop: "6px", marginRight: "12px", marginBottom: 0, marginLeft: "12px" }}>{errors.types} </FormHelperText>) : <></>}

                                                <Box sx={{ display: "grid" }}>
                                                    <Typography fontSize={20} lineHeight="22px" fontWeight={400} color="background: rgba(64, 67, 73, 1)" sx={{  'padding-top': '20px' }}>
                                                        {t("faq.label.questionFeild")}
                                                    </Typography>

                                                    <TextField
                                                        margin='normal'
                                                        classes={{ root: classes.TextField }}
                                                        fullWidth
                                                        style={styles.input}
                                                        name="QuestionType"
                                                        variant="outlined"
                                                        placeholder={t('faq.label.addQuestion')}
                                                        multiline
                                                        rows={5}
                                                        onChange={handleChange}
                                                        value={values.QuestionType}
                                                        error={Boolean(touched.QuestionType && errors.QuestionType)}
                                                        sx={Boolean(touched.QuestionType && errors.QuestionType) ? { color: "red", marginTop: "6px", marginBottom: '30px' } : {}}
                                                        helperText={touched.QuestionType && errors.QuestionType}
                                                        onBlur={handleBlur}
                                                    >

                                                    </TextField>


                                                    <Box sx={{ display: "flex", 'flex-direction': 'column', 'padding-top': '20px', paddingLeft: "5px" }} >

                                                        <Typography fontSize={20} lineHeight="22px" fontWeight={400} color="background: rgba(64, 67, 73, 1) " >
                                                            {t("faq.label.email")}
                                                        </Typography>

                                                        <Typography fontSize={13} lineHeight="24px" fontWeight={400} color="#A0A0A0" sx={{ 'padding-bottom': '0px', 'padding-top': '5px' }} >
                                                            {t("faq.label.detailmail")}
                                                        </Typography>
                                                    </Box>

                                                    <TextField
                                                        margin='normal'
                                                        classes={{ root: classes.TextField }}
                                                        fullWidth
                                                        style={styles.input}
                                                        name="emailAddress"
                                                        variant="outlined"
                                                        onChange={handleChange}
                                                        value={values.emailAddress}
                                                        placeholder={t('faq.label.emailAddress')}
                                                        error={Boolean(touched.emailAddress && errors.emailAddress)}
                                                        helperText={touched.emailAddress && errors.emailAddress}
                                                        onBlur={handleBlur}

                                                    >
                                                    </TextField>
                                                </Box>


                                                <Grid
                                                    item
                                                    xs
                                                    sm
                                                    md
                                                    lg
                                                    display="flex"
                                                    justifyContent="center"
                                                    margin="60px"

                                                >

                                                    <Button
                                                        size="small"
                                                        aria-controls="simple-menu"
                                                        aria-haspopup="true"
                                                        onClick={() => clickLink('/kpi/faq/listfaq')}
                                                        variant="contained"
                                                        sx={{ width: "103px", height: "40px", p: "0", textTransform: "none", marginRight: "35px", 'text-align': 'center', border: '1px solid #E4E4E4', background: "#FFFFFF !important" }}
                                                    >

                                                        <Typography fontSize={16} lineHeight="17.6px" fontWeight={400} color="#393939" >{t("faq.label.back")}</Typography>
                                                    </Button>

                                                    <Button
                                                        size="small"
                                                        aria-controls="simple-menu"
                                                        aria-haspopup="true"
                                                        onClick={() => handleSubmit()}
                                                        color="primary"
                                                        type="submit"
                                                        variant="contained"
                                                        sx={{ width: "103px", height: "40px", p: "0", textTransform: "none", 'text-align': 'center' }}
                                                    >

                                                        <Typography fontSize={16} lineHeight="17.6px" fontWeight={400}>{t("faq.label.send")}</Typography>
                                                    </Button>


                                                </Grid>

                                            </Box>

                                            : null

                                        }
                                    </form>
                                )}

                            </Formik>
                            :

                            <Box sx={{ margin: '0 auto', width: "100%", 'text-align': 'center', 'margin-top': 'inherit', 'margin-bottom': 'inherit' }}>

                                <SendSucess sx={{ width: "100%", height: "100%", marginTop: "70px" }} />
                                <Typography fontSize={24} lineHeight="26.4px" fontWeight={500} color="rgba(93, 161, 150, 1)" sx={{ paddingLeft: "40px", paddingRight: "40px", paddingTop: "30px", width: "100%", 'text-align': 'center' }}>
                                    {t("faq.label.sendSuccess")}
                                </Typography>

                                <Typography fontSize={18} lineHeight="24.6px" fontWeight={400} color="#404349" sx={{ paddingTop: "25px" }}>
                                    {t("faq.label.detailSendSuccess1")}
                                </Typography>
                                <Typography fontSize={18} lineHeight="24.6px" fontWeight={400} color="#404349" >
                                    {t("faq.label.detailSendSuccess2")}
                                </Typography>

                                <Button
                                    size="small"
                                    aria-controls="simple-menu"
                                    aria-haspopup="true"
                                    onClick={handleClose}
                                    color="primary"
                                    variant="contained"
                                    sx={{ width: "300px", height: "55px", p: "0", textTransform: "none", 'text-align': 'center', marginTop: "50px" }}
                                >

                                    <Typography fontSize={18} lineHeight="19.8px" fontWeight={400}>{t("faq.label.backToQuestion")}</Typography>
                                </Button>
                            </Box>
                        }


                    </Grid>


                </Grid>
            </Box >
        </>
    )
};
export default Question;


